import { Directive, Input, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
    standalone: false,
    selector: '[mas-validation-message]',
    host: {
        '[textContent]' : 'content',
        '[hidden]': 'control.valid || !control.dirty || !control.touched'
    }
})
export class ValidationMessageDirective implements OnInit {
    get content(): string {
        const control = this.control;
        if (!control) {
            return '';
        }
        if (control.valid || !control.dirty || !control.touched) {
            return '';
        }
        if (!control?.errors) {
            return '';
        }
        let required: string = '';
        for (const key in control.errors) {
            const message = this.errorMap.get(key) || ValidationMessageDirective.defaultErrorMap.get(key) || key;
            if (key === 'required') {   
                required = message;
                return message;
            } else {
                // console.warn(`this.control.name: ${this.control.name} value: ${this.control.value} message: ${message}`)
                return message;
            }
        }
        return required || 'Onbekende fout'; 
    }

    hidden: boolean = false;

    @Input('mas-validation-message')
    // control!: FormControl;
    control!: NgModel;

    private static defaultErrorMap: Map<string, string> = new Map([
        ['required', 'Dit veld is verplicht'],
        [ 'invalidNumber', 'Geen geldig getal'],
        [ 'tooLargeValue', 'Waarde is te hoog'],
        [ 'tooSmallValue', 'Waarde is te laag'],
        [ 'invalidDate', 'Geen geldige datum'],
        [ 'parseError', 'Geen geldige datum'],
        [ 'invalidError', 'Geen geldige datum'],
        [ 'minError', 'Minimum datum'],
        [ 'maxError', 'Maximum datum'],
        [ 'minAgeError', 'U dient minimaal 18 jaar oud te zijn.'],
        [ 'minlength', 'Waarde is te kort'],
        [ 'pattern', 'Ongeldige waarde']
    ]);

    @Input('error-map') errorMap: Map<string, string> = ValidationMessageDirective.defaultErrorMap;

    constructor() { }

    ngOnInit() {
        if (!this.control) {
            throw new Error('Please provide a form control on [mas-validation-message]');
        }
    }
}
